import React from 'react';

import { Box, BoxProps, Text } from '@mantine/core';

interface DroxyEmptyStateBoxProps extends BoxProps {
  message: string;
  children?: React.ReactNode;
}

export function DroxyEmptyStateBox({ message, children, ...boxProps }: DroxyEmptyStateBoxProps) {
  return (
    <Box
      p="xl"
      sx={(theme) => ({
        border: `2px dashed ${theme.colors.gray[2]}`,
        borderRadius: theme.radius.md,
        textAlign: 'center',
        backgroundColor: theme.colors.gray[0],
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing.md
      })}
      {...boxProps}>
      <Text c="dimmed" size="sm">
        {message}
      </Text>
      {children}
    </Box>
  );
}
